const selectGroupKey = Symbol("ElSelectGroup");
const selectKey = Symbol("ElSelect");
export { selectGroupKey, selectKey };